import React from 'react';
import PropTypes from 'prop-types';
import { designSystem } from '@yola/ws-ui';

const { Icon, Heading } = designSystem;

const Breadcrumbs = ({ breadcrumbs }) => (
  <div className="ws-breadcrumbs-container">
    {breadcrumbs.map((label, index) => (
      <React.Fragment key={label}>
        <Heading type="heading-6">{label}</Heading>
        {index < breadcrumbs.length - 1 && <Icon glyph="inter-right" />}
      </React.Fragment>
    ))}
  </div>
);

Breadcrumbs.propTypes = {
  breadcrumbs: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default Breadcrumbs;
